import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { SSBD_HTTP_503 } from '@app/constants/ssbd-http-503.constant';
import { TypesErrors } from '@app/enums/errors.enum';
import { TypeLoading } from '@app/enums';
import { ErrorModel } from '@models/micro/error.model';
import { Reservation } from '@app/models/micro';
import { MessagesService } from '@services/messages.service';
import { GlobalsService } from '@services/micro/globals.service';
import { GlobalsService as GlobalsServiceOld } from '@services/globals.service';
import { SbdService } from '@services/devices/sbd.service';
import { LoadingService } from '@services/loading.service';
import { messageParamsGeneric } from '@app/utils';
import { SsbdHttp503FailedRequest } from '@app/utils/ssbd-http-503-print.util';

@Injectable({
  providedIn: 'root',
})
export class SsbdHttp503Handler {
  private handling = false;
  private failedRequest: SsbdHttp503FailedRequest | null = null;

  constructor(
    private readonly _messages: MessagesService,
    private readonly _globals: GlobalsService,
    private readonly _globalsOld: GlobalsServiceOld,
    private readonly _router: Router,
    private readonly _ssbd: SbdService,
    private readonly _loading: LoadingService
  ) {}

  handleIfHttp503(
    error: ErrorModel | HttpErrorResponse | null | undefined,
    failedRequest?: SsbdHttp503FailedRequest | null
  ): boolean {
    if (!this.isHttp503(error)) {
      return false;
    }
    this.failedRequest = failedRequest ?? this.extractFailedRequest(error);
    this.showModalPrintAndCloseSession();
    return true;
  }

  private extractFailedRequest(
    error: ErrorModel | HttpErrorResponse | null | undefined
  ): SsbdHttp503FailedRequest | null {
    if (error instanceof HttpErrorResponse && error.url) {
      return { url: error.url };
    }
    return null;
  }

  private isHttp503(error: ErrorModel | HttpErrorResponse | null | undefined): boolean {
    if (!error) {
      return false;
    }
    if (error instanceof HttpErrorResponse) {
      return error.status === SSBD_HTTP_503.HTTP_STATUS;
    }
    return Number(error.getCode?.() ?? error.code) === SSBD_HTTP_503.HTTP_STATUS;
  }

  private showModalPrintAndCloseSession(): void {
    if (this.handling) {
      return;
    }
    this.handling = true;
    this.hideLoadings();

    const reservation = this._globals.getReservation();

    const timeoutId = window.setTimeout(() => {
      this._messages.closeAll();
    }, SSBD_HTTP_503.MODAL_TIMEOUT_MS);

    this._messages
      .error(
        { typesError: TypesErrors.SSBD_HTTP_503 },
        '',
        TypesErrors.SSBD_HTTP_503,
        {
          ...messageParamsGeneric,
          buttonCopy: 'errorMsj.ssbdHttp503.button',
          showClose: false,
        },
        undefined,
        true
      )
      .finally(() => {
        clearTimeout(timeoutId);
        this.printAgentCard(reservation);
        this.closeSsbdSession();
      });
  }

  private hideLoadings(): void {
    this._loading.hideLoading(TypeLoading.FOOTER_LOADING);
    this._loading.hideLoading(TypeLoading.COMPONENT_LOADING);
    this._loading.hideLoading(TypeLoading.FULL_LOADING);
  }

  private printAgentCard(reservation: Reservation | null): void {
    this._messages.printErrorCard(
      TypesErrors.SSBD_HTTP_503,
      {
        code: String(SSBD_HTTP_503.HTTP_STATUS),
        failedRequest: this.failedRequest,
      },
      reservation?.pnr,
      reservation,
      null,
      this.failedRequest?.url ?? ''
    );
  }

  private closeSsbdSession(): void {
    this.handling = false;
    this.failedRequest = null;
    this._ssbd.disable();
    this._globals.clearAll();
    this._globalsOld.clearAll();
    this._messages.closeAll();
    this._router.navigate(['/']);
  }
}
